import { useQuery } from '@tanstack/react-query';
import { auth } from '@cwos/api-client';

/**
 * THE ORGANIZATION'S CALENDAR — the zone and the week start every analytics
 * week and preset is cut on (Generation Hope: America/Chicago, Sunday). The
 * Schedule's Week and Month grids and the analytics drill windows draw on it,
 * so a week on the board is the week the dashboard counted.
 *
 * Read off `/auth/me` under the key `usePermissions` already caches, so it
 * costs no request. `known: false` while that read is out, or from a server
 * older than the fields: the device's zone and Monday stand in, the board's
 * old behaviour, and a caption can say whose calendar it is.
 */
export interface OrgCalendar {
  timeZone: string;
  /** 0 = Sunday … 6 = Saturday. */
  weekStartsOn: number;
  known: boolean;
}

export function useOrgCalendar(): OrgCalendar {
  const me = useQuery({
    queryKey: ['auth', 'me', 'permissions'],
    queryFn: () => auth.me(),
    staleTime: 5 * 60_000,
  });
  const timeZone = me.data?.orgTimezone;
  const weekStartsOn = me.data?.orgWeekStartsOn;
  return timeZone && weekStartsOn != null
    ? { timeZone, weekStartsOn, known: true }
    : {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        weekStartsOn: 1,
        known: false,
      };
}
